module.exports = __webpack_public_path__ + "img/hair_back_female_ponytail_mask.c0ebda13.png";